/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ScheduledValidatorPruneDto } from '../models/ScheduledValidatorPruneDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ValidatorPruneControllerService {

    /**
     * @param name
     * @returns ScheduledValidatorPruneDto OK
     * @throws ApiError
     */
    public static getValidatorPruningSchedule(
        name: string,
    ): CancelablePromise<ScheduledValidatorPruneDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/validators/{name}/prune',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateValidatorPruningSchedule(
        name: string,
        requestBody: ScheduledValidatorPruneDto,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/validators/{name}/prune',
            path: {
                'name': name,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public static createValidatorPruningSchedule(
        name: string,
        requestBody: ScheduledValidatorPruneDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/validators/{name}/prune',
            path: {
                'name': name,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns void
     * @throws ApiError
     */
    public static deleteValidatorPruningSchedule(
        name: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/validators/{name}/prune',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
